export default "__VITE_ASSET__DwNgGYKt__"